import {GateKeeperRecordDto} from "../services/messages/GateKeeperRecordDto";
import {DecryptedGateKeeperAccount} from '../domain/DecryptedGateKeeperAccount';
import {FullEmailThreadContent} from "../domain/EmailContentDto";
import {PgpKey} from "../domain/PgpKey";
import {FileDto} from "../services/protected/dto/FileDto";
import DbDraftEmail from "../domain/DbDraftEmail";

export type AccountRecordItem = GateKeeperRecordDto | FullEmailThreadContent | FileDto | DbDraftEmail | PgpKey;

export interface AccountsState {
    accounts: GateKeeperRecordDto[];

    accountSearchText: string;

    secretKeys: PgpKey[];
    secretKeysLoaded: boolean;

    pgpKeys: PgpKey[];
    pgpKeysLoaded: boolean;
    pgpKeyAddresses: string[];

    password: string;
    passwordRequired: boolean;
    passwordError: string;
    passwordRequiredForItem: AccountRecordItem;
    keyDescription: string | null;

    editAccount: DecryptedGateKeeperAccount | null;
    accountHistory: DecryptedGateKeeperAccount[] | null;
}

export const BlankGateKeeperAccount: GateKeeperRecordDto = {
    Id: -1,
    IsOwner: true,
    ClientId: "", EntityId: -1, Category: "", CreateTime: 0, DataXml: "", EncryptedDataXml: "", Image: "", IsArchived: 0, Name: "",
    PublicKeyShares: [],
};

export const initialAccountsState: AccountsState = {
    accounts: [],

    accountSearchText: "",

    secretKeys: [],
    secretKeysLoaded: false,

    pgpKeys: [],
    pgpKeysLoaded: false,
    pgpKeyAddresses: [],

    passwordRequired: false,
    password: window.localStorage.getItem("pw") || "",
    passwordError: "",
    passwordRequiredForItem: BlankGateKeeperAccount,
    keyDescription: null,
    editAccount: null,
    accountHistory: null,
};
